import { render, staticRenderFns } from "./activitiesDetail2021ts.vue?vue&type=template&id=0d5e6230&scoped=true"
import script from "./activitiesDetail2021ts.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2021ts.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2021ts.vue?vue&type=style&index=0&id=0d5e6230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e6230",
  null
  
)

export default component.exports